<div class="flex flex-col gap-4 p-1">
  <div class="flex flex-col gap-2">
    <h2 class="text-lg font-semibold tracking-tight">{{ title }}</h2>
    <p class="text-sm text-muted-foreground whitespace-pre-wrap">{{ text }}</p>
  </div>

  <div class="flex justify-end">
    <button type="button" z-button (click)="closeDialog()">
      {{ buttonText }}
    </button>
  </div>
</div>
